import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import useField from '../hooks/use-field'

function TextArea (props) {
  const field = useField(props)

  return field.wrap((fieldProps) => (
    <textarea
      id={field.id}
      name={field.name}
      value={field.value}
      placeholder={field.placeholder}
      disabled={field.disabled}
      readOnly={field.readOnly}
      onChange={e => field.onChange(e.target.value)}
      style={{ height: props.height }}
      onBlur={field.onBlur}
      onFocus={field.onFocus}
      {...fieldProps}
    />
  ))
}

TextArea.defaultProps = {
  defaultValue: null,
  placeholder: '',
  readOnly: false,
  disabled: false,
  required: false,
  className: '',
  height: 'auto'
}

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  height: PropTypes.any
}

export default observer(TextArea)
